import { Component, OnInit, Input, ViewChild, EventEmitter, Output, OnDestroy, inject } from "@angular/core";
import { AuthService } from 'src/app/services/auth.service';
import { WasteModuleService } from 'src/app/services/waste-module.service';
import { ResolutionCodingService } from 'src/app/services/resolution-coding.service';
import { DocumentService } from "src/app/services/document.service";
import { environment } from "src/environments/environment";
import { ShareModalComponent } from "../share-modal/share-modal.component";
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';

@Component({
    selector: "app-wm-comment-modal",
    templateUrl: "./comment-modal.component.html",
    styleUrls: ["./comment-modal.component.css"],
    standalone: false
})
export class CommentModalComponent implements OnInit, OnDestroy {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private service = inject(WasteModuleService);
  authService = inject(AuthService);
  private resolutionCodingService = inject(ResolutionCodingService);
  documentService = inject(DocumentService);

  @Input() selectedRow: any;
  @Input() deId=false;
  @Output() shareAdminStatus = new EventEmitter();
  userMentions: object[] = [];
  taggedUsers: object[] = [];
  comment!: string;
  wasVerified=false;
  resCoding! : string;
  comments: any;
  resolutionOptions:any;
  practiceIssueOptions:any;
  pracIssue:any=[];
  transType! : boolean;
  msgs!:[];
  pollInterval:any;
  totalCount: any = 0;
  isLocked = false;
  lockInfo:any = null
  lockMessage = '';
  showShareModal = false
  @ViewChild('shareModal') shareComponent!: ShareModalComponent;
  @Output() completed = new EventEmitter<any>();
  tab = 2;
  WasteModuleService: any;
  ngOnInit(): void {
    try {
      this.practiceIssueOptions = this.resolutionCodingService.getPracticeIssueOptions();
    }
    catch {
      this.resolutionCodingService.getNewResolutionCode().subscribe(() => {
        this.practiceIssueOptions = this.resolutionCodingService.getPracticeIssueOptions();
      })
    }
  }
  
  changingOfPass(pass: any) {
    if (pass == true) {
      return "Yes"
    }
    else if (pass == false) {
      return "No"
    }
  }
  changingOfFail(fail: any) {
    if (fail == true) {
      return "Yes"
    }
    else if (fail == false) {
      return "No"
    }
  }

  openTab(num: any){
    this.documentService.tab = num;
  }

  async setData(rowData: any) {
    try {
      this.selectedRow = rowData;
      this.taggedUsers = [];
      const date = this.selectedRow["varDateString"].replace('T', ' ').split('.')[0]
      const key = this.selectedRow["lanId"]+this.selectedRow["medId"]+date
      this.pracIssue = this.selectedRow.practiceIssue
      this.service.getComments(key).subscribe((res)=>{
        this.comments = (res as any)["docs"].reverse();
        if(typeof (res as any)["docs"][0].practiceIssue == 'string' && (res as any)["docs"][0]) {
          this.pracIssue = [(res as any)["docs"][0].practiceIssue]
        }else {
          this.pracIssue = (res as any)["docs"][0].practiceIssue
        }
      })
      this.transType = (this.selectedRow.transType=='Verified')?true:false;
      if(this.transType){
        this.wasVerified = true
      }
      this.comment = "";
      this.resCoding = this.selectedRow.resolutionCoding;
      // let date = new DatePipe('en-US').transform(this.selectedRow["varDateString"], 'yyyy-MM-dd', 'GMT') + ' ' +moment(this.selectedRow["varDate"]).format("HH:mm:ss")
      this.selectedRow["varDate"] = new Date(this.selectedRow["varDateString"]).toLocaleString();
      //Updating the formatting on the Waste parameters to be more friendly. Added by Mitch 1/20/2023 - edited by Mitch 2/1/2023
      if (this.selectedRow.wasteAmountRecieved != null && typeof this.selectedRow.wasteAmountRecieved !== 'undefined'){
        this.selectedRow.wasteAmountRecieved= +this.selectedRow.wasteAmountRecieved;
      }
      if (this.selectedRow.expectedWaste != null && typeof this.selectedRow.expectedWaste !== 'undefined'){
      this.selectedRow.expectedWaste = +this.selectedRow.expectedWaste;
      }
      // this.WasteModuleService.getIndvActComments(key, adminId, maapKey).subscribe((res)=>{
      //   this.comments = res["docs"].reverse();
      //   this.totalCount = res["count"];
      // });
    } catch (err) { 
      this.logger.exception(err);
      this.comments = [];
    }
  }

  //This function is called when the one click resolution modal view is opened. I'm not sure why the setData function is never called but as I can tell
  // it is never being executed. -Mitch 2/1/2023 
  async getComments(rowData: any) {
    try {
      this.selectedRow = rowData;
      this.taggedUsers = [];
      this.transType = (this.selectedRow.transType=='Verified')?true:false; 
      this.resCoding = this.selectedRow.resolutionCoding;
      if(this.selectedRow["source"] == "Assay")
      {
        this.resolutionOptions = this.resolutionCodingService.getRosolutionCodingData("waste_assay");
      }
      else
      {
        this.resolutionOptions = this.resolutionCodingService.getRosolutionCodingData("waste_recon");
      }

      //Updating the formatting on the Waste parameters to be more friendly. Added by Mitch 1/20/2023 - edited by Mitch 2/1/2023
      if (this.selectedRow.wasteAmountRecieved != null && typeof this.selectedRow.wasteAmountRecieved !== 'undefined' && this.selectedRow.wasteAmountRecieved){
        this.selectedRow.wasteAmountRecieved= +this.selectedRow.wasteAmountRecieved;
      }
      if (this.selectedRow.expectedWaste != null && typeof this.selectedRow.expectedWaste !== 'undefined'){
        this.selectedRow.expectedWaste = +this.selectedRow.expectedWaste;
      }

      this.comment = "";
      this.resCoding = this.selectedRow.resolutionCoding;
      // let date = new DatePipe('en-US').transform(this.selectedRow["varDateString"], 'yyyy-MM-dd', 'GMT') + ' ' +moment(this.selectedRow["varDate"]).format("HH:mm:ss")
      // let date = new DatePipe('en-US').transform(this.selectedRow["varDateString"], 'yyyy-MM-dd HH:mm:ss') //+ ' ' +moment(this.selectedRow["varDate"]).format("HH:mm:ss")
      const date = this.selectedRow["varDateString"].replace('T', ' ').split('.')[0]
  
      const key = this.selectedRow["lanId"]+this.selectedRow["medId"]+date

      this.service.getComments(key).subscribe((res)=>{

        this.comments = (res as any)["docs"].reverse();
        if(this.comments.length > 0){
          this.selectedRow.comment = this.comments[0].comment
        }
        this.pracIssue = this.selectedRow.practiceIssue
        if(typeof (res as any)["docs"][0].practiceIssue == 'string' && (res as any)["docs"][0]) {
          this.pracIssue = [(res as any)["docs"][0].practiceIssue]
        }else {
          this.pracIssue = (res as any)["docs"][0].practiceIssue
        }
      });


    } catch (err) { 
      this.logger.exception(err);
      this.comments = [];
    }
  }

  async closeDialog(){
    this.completed.emit(true);
  }

  //Update the Verified checkbox MV2-425 on line no 87,89 and 96
  async submit() {
    try {
      // let date = new DatePipe('en-US').transform(this.selectedRow["varDateString"], 'yyyy-MM-dd', 'GMT') + ' ' +moment(this.selectedRow["varDate"]).format("HH:mm:ss")
      const date = this.selectedRow["varDateString"].replace('T', ' ').split('.')[0]
      const formattedDate = this.selectedRow['varDateString'].replace("T", " ").slice(0,-8)
      const key = this.selectedRow["lanId"]+this.selectedRow["medId"]+date
      const transType = (this.transType) ? 'Verified' : ''
      const adminName = (this.deId) ? '******, ******' : this.selectedRow['employeeName']
      //Update MV2-445 changes
      const data = await this.service.submitComment(
        this.selectedRow["id"], 
        this.comment,
        this.resCoding,
        this.selectedRow.practiceIssue, 
        key,
        this.selectedRow.source,
        transType, 
        this.taggedUsers, 
        this.selectedRow['lanId'], 
        this.selectedRow['adminGroup'], 
        adminName, 
        this.selectedRow['loc'],
        this.selectedRow['mrnNum'],
        formattedDate,
        this.selectedRow.medDesc,
        this.wasVerified)
        .subscribe(
          () => {
           const message= {
            life:5000,
             severity: 'success', 
             summary: 'Updated Successfully',
             detail: '',
            }
            //Update MV2-445 changes
            this.selectedRow.comment = this.comment;
            this.selectedRow.resolutionCoding = this.resCoding;
            this.selectedRow.practiceIssue = this.pracIssue;
            this.selectedRow.loggedInUserName = (data as any)["loggedInUserName"];
            this.selectedRow.witnessName = (data as any)["witnessName"];
            this.selectedRow.transType = transType;
            this.completed.emit(message);
          },
          (err) => {
            const message= {
              life:5000,
              severity: 'error', 
              summary: 'Update Failed',
              detail: err.error.message,
             }
             this.completed.emit(message);
          }
        );

    } catch {
      // Intentionally ignore here; API error is handled by the observable callback.
    }
  }  

  formatDateCustom(dateStr: string): string {
    let output = '';
    const dateObj = new Date(dateStr); // creating new object from date string
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
    // takes jan as 0, so we have to update it by 1 
    output += month + '/';
    const date = (dateObj.getUTCDate()).toString().padStart(2, '0');
    output += date + '/';
    const fullYear = dateObj.getUTCFullYear();
    output += fullYear + ' | ';
    const hours = (dateObj.getUTCHours()).toString().padStart(2, '0');
    output += hours + ':';
    const minutes = (dateObj.getUTCMinutes()).toString().padStart(2, '0');
    output += minutes;
    return output;
  }
  
  startPolling(){
    this.stopPolling();
    this.pollInterval = setInterval(() => {
      this.checkStatus()
    }, environment.lockDuration||60);
    this.checkStatus()
  }

  stopPolling(){
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }

  checkStatus(){
    this.documentService.checkLockStatus(this.selectedRow["id"], "waste").subscribe((response)=>{
      this.isLocked = (response as any)["islocked"]
      this.lockInfo = response
      this.lockMessage = this.buildLockMessage();
    },
    ()=>{
      this.isLocked = true
      this.lockMessage = '';
    }
    )
  }

  private buildLockMessage(): string {
    if (this.lockInfo == null) return '';
    try {
      if (["", null].includes(this.lockInfo["lasteEditedBy"])) {
        return "";
      }
      if (!this.isLocked) {
        const createdDate = new Date(
          this.lockInfo["lastEditedAt"]
        ).toLocaleString();
        return (
          "Last Edited By (" +
          this.lockInfo["lasteEditedBy"] +
          " - " +
          createdDate +
          ")"
        );
      } else {
        if (["", null].includes(this.lockInfo["userName"])) {
          return "";
        }
        return "In Use By " + this.lockInfo["userName"];
      }
    } catch {
      return "";
    }
  }

  ngOnDestroy(){
    this.stopPolling();
  }

  shareAdminFollowUp(){
    this.shareAdminStatus.emit(this.selectedRow);
  }

  updateDocumentCount(count: any) {
    if(this.totalCount > 0){
      this.totalCount=this.totalCount - count;
    } else {
      this.totalCount = 0;
    }
  }

  updateCount(count: any){
    this.totalCount=this.totalCount + count;
  }

  isDeId(name: any){
    if(this.deId)
      return "xxxxxx xxxxxx"
    else
      return name
  }
  getUserMentions(){
    this.authService.getActiveUsers().subscribe((res)=>{
      this.userMentions = (res as any)['users']
    })
  }

}
